import React, {
  useEffect,
  useState,
  useCallback,
  useContext,
  useRef,
} from "react";

import * as Yup from "yup";
import { useFormik } from "formik";
import AOS from "aos";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Logindetail } from "../../context/Logindetail.js";
import instance from "../../Config/Config.js";
import { Country_fun } from "../../api/Controllapi.js";
import toast from "react-hot-toast"

const AddressFormProfileEdit = ({ setting_data }) => {
  const { id } = useParams();
  const [spinner, setspinner] = useState(false);
  const location = useLocation();
  const { token, detail_info, setdetail_info } = useContext(Logindetail);
  const totalPrice = location.state?.total;
  const previousRoute = location.state?.from;

  const [addressEdit, setAddressedit] = useState();

  // console.log("addressEdit", addressEdit)



  const initValue = {
    country: addressEdit?.country || "",
    state: addressEdit?.state || "",
    city: addressEdit?.city || "",
    postal_code: addressEdit?.postal_code || "",
    requirement: addressEdit?.address_line_1 || "",
    selection: addressEdit?.type?.toString() || "",
  };

  const updateSchema = Yup.object().shape({
    country: Yup.string().required("Country is required"),
    state: Yup.string().required("State is required"),
    city: Yup.string().required("Enter Your City"),
    requirement: Yup.string().required("Address is required"),
    postal_code: Yup.string().required("Postal code is required"),
    selection: Yup.string().required("Address Type is required"),
  });

  const formik = useFormik({
    initialValues: initValue,
    enableReinitialize: true,
    validationSchema: updateSchema,
    onSubmit: async (values, { setErrors, resetForm }) => {
      const data = {
        address: values.requirement,
        country_id: parseInt(values.country),
        state_id: parseInt(values.state),
        city_id: parseInt(values.city),
        postal_code: values.postal_code,
        type: parseInt(values.selection),
      };

      try {
        setspinner(true);
        const responseApi = await instance.post("address", data);
        toast.success("Address updated successfully");
        if (previousRoute === "profile") {
          router("/user/myprofile");
        } else {
          router("/checkout", {
            state: {
              total: totalPrice,
            },
          });
        }
      } catch (err) {
        console.error("Failed to save address:", err);
        toast.error("Failed to save address");
      } finally {
        setspinner(false);
      }
    },
  });

  useEffect(() => {
    if (formik.submitCount > 0 && !formik.isValid) {
      const checkOrder = [
        "selection",
        "country",
        "state",
        "city",
        "postal_code",
        "requirement",
      ];

      const firstErrorKey = checkOrder.find((key) => formik.errors[key]);
      if (firstErrorKey) {
        toast.error(formik.errors[firstErrorKey]);
      }
    }
  }, [formik.submitCount]);
  useEffect(() => {
    AOS.init({
      duration: 1500,
    });
  }, []);


  const router = useNavigate();
  const [countryList, setCountryList] = useState([]);
  const [selectedCountryId, setSelectedCountryId] = useState(addressEdit?.country);
  const [stateList, setStateList] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState(addressEdit?.state);
  const [cityList, setCityList] = useState([]);


  const fetchCountries = async () => {
    try {
      const responseApi = await instance.get("get_country");

      setCountryList(responseApi?.data?.data || []);
    } catch (err) {
      console.error("Failed to fetch countries:", err);
    }
  };

  useEffect(() => {
    const fetchStates = async () => {
      if (!selectedCountryId) return;
      try {
        const responseApi = await instance.get("get_state", {
          params: { country_id: selectedCountryId || addressEdit?.country  },
        });

        setStateList(responseApi?.data?.data || []);
      } catch (err) {
        console.error("Failed to fetch states:", err);
      }
    };

    fetchStates();
  }, [selectedCountryId]);

  useEffect(() => {
    const fetchCities = async () => {
      if (!selectedCountryId || !selectedStateId) return;

      try {
        const responseApi = await instance.get("get_city", {
          params: {
            country_id: selectedCountryId || addressEdit?.country,
            state_id: selectedStateId || addressEdit?.state,
          },
        });

        setCityList(responseApi?.data?.data || []);
      } catch (err) {
        console.error("Failed to fetch cities:", err);
      }
    };

    fetchCities();
  }, [selectedCountryId, selectedStateId]); // ✅ Dependencies

  useEffect(() => {
    fetchCountries();
  }, []);

    const GetCheckoutList = async () => {
    try {
      const responseApi = await instance.get(`address/edit`, {
        params: { id: id },
      });
      setAddressedit(responseApi?.data?.data);
      setSelectedCountryId(responseApi?.data?.data.country)
      setSelectedStateId(responseApi?.data?.data.state)
    } catch (error) {
      console.error(
        "Error fetching cart:",
        error.response?.data || error.message
      );
    }
  };
  useEffect(() => {
    GetCheckoutList();
  }, []);




  return (
    <div className="container mt-5 mb-5 pt-3">
      <section>
        <div className="container mt-5 " data-aos="fade-up">
          <div className="d-flex justify-content-center contact-form2">
            <form onSubmit={formik.handleSubmit}>
              <div className="row">
                {/* Address Type */}
                <div className="form-group col-md-12 col-sm-12 col-12 login-text mb-3">
                  <label>
                    Address Type <span className="text-danger">*</span>
                  </label>
                  <div className="d-flex gap-4">
                    <div>
                      <input
                        type="radio"
                        id="option1"
                        name="selection"
                        value="1"
                        checked={formik.values.selection === "1"}
                        onChange={formik.handleChange}
                      />
                      <label htmlFor="option1" className="ms-1">
                        Home
                      </label>
                    </div>

                    <div>
                      <input
                        type="radio"
                        id="option2"
                        name="selection"
                        value="2"
                        checked={formik.values.selection === "2"}
                        onChange={formik.handleChange}
                      />
                      <label htmlFor="option2" className="ms-1">
                        Work
                      </label>
                    </div>

                    <div>
                      <input
                        type="radio"
                        id="option3"
                        name="selection"
                        value="3"
                        checked={formik.values.selection === "3"}
                        onChange={formik.handleChange}
                      />
                      <label htmlFor="option3" className="ms-1">
                        Other
                      </label>
                    </div>
                  </div>
                </div>

                {/* Country */}
                <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                  <label>
                    Country <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control forminputpad"
                    id="inputCountry"
                    value={formik.values.country}
                    onChange={(e) => {
                      const selectedCountryId = e.target.value;
                      formik.setFieldValue("country", selectedCountryId);
                      setSelectedCountryId(selectedCountryId);
                    }}
                  >
                    <option value="" disabled>
                      Select Country
                    </option>
                    {countryList.map((country) => (
                      <option key={country.id} value={country.id}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* State */}
                <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                  <label>
                    State <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control forminputpad"
                    id="inputState"
                    value={formik.values.state}
                    onChange={(e) => {
                      const selectedStateId = e.target.value;
                      formik.setFieldValue("state", selectedStateId);
                      setSelectedStateId(selectedStateId);
                    }}
                  >
                    <option value="" disabled>
                      Select State
                    </option>
                    {stateList.map((state) => (
                      <option key={state.id} value={state.id}>
                        {state.state}
                      </option>
                    ))}
                  </select>
                </div>

                {/* City */}
                <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                  <label>
                    City <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control forminputpad"
                    id="inputCity"
                    value={formik.values.city}
                    onChange={(e) => {
                      const selectedCityId = e.target.value;
                      formik.setFieldValue("city", selectedCityId);
                    }}
                  >
                    <option value="" disabled>
                      Select City
                    </option>
                    {cityList.map((city) => (
                      <option key={city.id} value={city.id}>
                        {city.city}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Postal Code */}
                <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                  <label>
                    Postal Code <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="inputPostalCode"
                    placeholder="Postal code"
                    {...formik.getFieldProps("postal_code")}
                  />
                </div>
              </div>

              {/* Address */}
              <div className="form-group submit login-text">
                <label>
                  Address <span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows={5}
                  placeholder="Address"
                  {...formik.getFieldProps("requirement")}
                ></textarea>
              </div>

              <div className="d-flex justify-content-end">
                <button className="text-white" type="submit" disabled={spinner}>
                  {spinner ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                    ></span>
                  ) : (
                    <b>Submit</b>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddressFormProfileEdit;
